import { NonMemoizedOptimizedImage } from '../components/OptimizedImage/OptimizedImage';
import Link from '../components/Link/Link';
import TableOfContents from '../components/TableOfContents/TableOfContents';
import SeriesOfArticles, {
  Description_SeriesOfArticles,
  Title_SeriesOfArticles,
} from '../components/SeriesOfArticles/SeriesOfArticles';
import AbilityFromViewModel from '../components/AbilityFromViewModel/AbilityFromViewModel';

const enhancedMarkdownOverrides = {
  Image: NonMemoizedOptimizedImage,
  img: NonMemoizedOptimizedImage,
  a: Link,
  TableOfContents: TableOfContents,
  SeriesOfArticles: SeriesOfArticles,
  Title_SeriesOfArticles: Title_SeriesOfArticles,
  Description_SeriesOfArticles: Description_SeriesOfArticles,
  Ability: AbilityFromViewModel,
};
export default enhancedMarkdownOverrides;
